import { EMPTY, of } from "rxjs";
import { filter, switchMap } from "rxjs/operators";
import { selectIsGridVisible, selectSelectedBuildingInfo, } from "../../../../selectors/selectExistingBuildingInfo";
import { utilBuildings } from "../../../../utils/utilBuildings";
import { actionBuildingsCancelMove, actionBuildingsDeselect } from "../actionBuildings";
import { TypeBuildingAction } from "../reducerBuildings";
export var epicBuildingDeselectOnDrag = function (action$, state$, deps) {
    return deps.inStoreDependencies.viewportChanged$.pipe(filter(function () {
        return selectSelectedBuildingInfo(state$.value) !== undefined;
    }), switchMap(function (viewport) {
        var state = state$.value;
        var selectedBuilding = selectSelectedBuildingInfo(state);
        var isNewBuilding = state.playerBase.buildings.action === TypeBuildingAction.Construct;
        var shouldClose = utilBuildings.getBuildingContextMenuShouldClose(utilBuildings.getHoverPositionOnScreen(selectedBuilding, viewport).x, selectedBuilding.proto.posX, utilBuildings.getBuildingDimensions(selectedBuilding).width);
        var isGridVisible = selectIsGridVisible(state$.value);
        if (isGridVisible && shouldClose && !isNewBuilding) {
            return of(actionBuildingsCancelMove());
        }
        if (shouldClose && !isNewBuilding) {
            return of(actionBuildingsDeselect());
        }
        return EMPTY;
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/epics/epicBuildingDeselectOnDrag.ts
// module id = 2044
// module chunks = 3